import React, { Component } from "react";
import { Carousel } from "antd";
import {LeftOutlined, RightOutlined } from '@ant-design/icons';

import "./home-slider.scss";


export default class HomeSlider extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.carousel = React.createRef();
  }
  next() {
    this.carousel.next();
  }
  previous() {
    this.carousel.prev();
  }

  render() {
    const props = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div  className="home-slider-carousel">
        <LeftOutlined onClick={this.previous} className="left-arrow-carousel"  />

        <Carousel ref={node => (this.carousel = node)} {...props} autoplay>


           <div className="home-slider-bg1"> 
              <div className="home-slider-content">
                  <h4>تفطير </h4>
                  <h1>الصائمين </h1>
              </div>
           </div>  

           <div className="home-slider-bg2"> 
              <div className="home-slider-content">
                  <h4>تأهيل العاملين والمستفيدين  </h4>
                  <h1>في العمل الخيري </h1>
              </div>
           </div>  
           <div className="home-slider-bg3"> 
              <div className="home-slider-content">
                  <h4> ...الأعظم <span className="home-slider-content-sp1">أجـراً</span> </h4>
                  <h4> ...الأكثر <span className="home-slider-content-sp1">نفعــاً</span>  </h4>
              </div>
           </div>  
        </Carousel>

        <RightOutlined  onClick={this.next} className="right-arrow-carousel"  />
      </div>
    );
  }
}




